;(function($){

    function Mask() {
   	 	$(document).find('[name=phone]').mask('(00) 0000-0000');
        $(document).find('[name=cellphone]').mask('(00) 00000-0000');
        $(document).find('[name=cpf]').mask('999.999.999-99');
        $(document).find('[data-formate]').mask('99-99-9999');
        $(document).find("[name=cnpj]").mask("99.999.999/9999-99");
        $(document).find("[name=postal_code]").mask("99999-999");
        $(document).find('[data-money]').mask('000.000.000.000.000,00', {reverse: true});
        $(document).find('[data-integrate]').mask('0#');
        $(document).find('[data-percentage]').mask('##0.00', {reverse: true});
        $(document).find('[data-cref]').mask('999999-A/AA');
        $(document).find('[name=vacancies], [name=age_group], [name=plots]').mask('##000000000000000');
        $(document).find('[name=schedule_init], [name=schedule_end]').mask('99:99');        
    }

   	new Mask();

}(jQuery));